var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2185 4.76806C12.8457 3.14087 15.4839 3.14087 17.1111 4.76806L17.397 5.05401C19.0242 6.6812 19.0243 9.3194 17.397 10.9466L14.6111 13.7326C12.9839 15.3597 10.3457 15.3597 8.71852 13.7325L8.4326 13.4466C7.75235 12.7663 7.35571 11.9072 7.24464 11.0206L7.14105 10.1936L8.79477 9.98648L8.89835 10.8134C8.96502 11.3455 9.20194 11.8589 9.6111 12.2681L9.89702 12.554C10.8734 13.5303 12.4563 13.5303 13.4326 12.554L16.2185 9.76807C17.1949 8.79175 17.1949 7.20883 16.2185 6.23252L15.9326 5.94657C14.9563 4.97029 13.3734 4.97026 12.3971 5.94649L11.665 6.6788L10.4864 5.50044L11.2185 4.76806ZM5.38525 8.10139C7.01244 6.47421 9.6506 6.47421 11.2778 8.10139L11.5638 8.38735C12.244 9.06756 12.6406 9.92673 12.7517 10.8134L12.8553 11.6402L11.2015 11.8474L11.0979 11.0206C11.0313 10.4885 10.7944 9.97498 10.3853 9.5659L10.0993 9.2799C9.12302 8.30359 7.54007 8.30359 6.56376 9.2799L3.77781 12.0659C2.8015 13.0421 2.8015 14.6251 3.77781 15.6014L4.06376 15.8873C5.04007 16.8636 6.62299 16.8636 7.5993 15.8873L8.33148 15.1551L9.51002 16.3336L8.77785 17.0658C7.15065 18.693 4.51243 18.6931 2.88525 17.0658L2.5993 16.7799C0.972114 15.1527 0.972105 12.5146 2.5993 10.8873L5.38525 8.10139Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.134da1af470e9a287fb4c6998644038c.svg";
export { ForwardRef as ReactComponent };